import { dispatchErrorWrap, dispatchSuccessWrap } from './genericActions'

import { actionTypes } from '../types'
import { constants } from '../../App.constants';
import moment from 'moment'

import axios from 'axios';
import { apiFailure } from '../../components/shared/memberEdit';

export const makeCardAsDefault = (cardId, customerId, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            cardId: cardId
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", data, headers)
            dispatchSuccessWrap(actionTypes.MAKE_CARD_DEFAULT, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const getBankAccountToken = (plaid_link_public_token, account_id, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const data = {
            plaid_link_public_token: plaid_link_public_token,
            account_id: account_id
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/create_bank_token', data, headers)
            dispatchSuccessWrap(actionTypes.CREATE_BANK_TOKEN, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const getLinkAccountToken = (user, redirectUri, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const data = {
            clientName: 'Tanglewood Resort',
            redirectUri: redirectUri
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/user/' + user + '/create_link_token', data, headers);
            dispatchSuccessWrap(actionTypes.GET_LINK_TOKEN, {
                token: payload.link_token
            }, dispatch)

            cb(null, payload)
        } catch (error) {
            cb(error)
        }
    }
}



export const getFutureTeeTickets = (cb) => {
    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.get(constants.ticketsBaseUrl + '/calendar/' + constants.selectedCalendar + '/users/' + localStorage.getItem('userId') + "/tees", headers)

            let upcomingTees = []
            if (payload.data && payload.data.tickets) {

                payload.data.tickets.forEach(function (ticket) {
                    if (moment(new Date(ticket.eventInfo.startDate)).isSameOrAfter(moment(new Date()).startOf('day'))) {
                        upcomingTees.push(ticket);
                    }

                });
                console.log(payload.data.tickets)
                dispatchSuccessWrap(actionTypes.GET_FUTURE_TEE_TICKETS, {
                    tickets: upcomingTees
                }, dispatch)
                cb()
            } else {
                cb()
                dispatchErrorWrap(actionTypes.ERROR, dispatch)
            }

        } catch (error) {
            //cb()
            cb()
            dispatchErrorWrap(actionTypes.ERROR, dispatch)

        }


    }
}

export const deleteCard = (cardId, customerId, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            },
            data: {
                cardId: cardId
            }
        }



        try {
            const payload = await axios.delete(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/removeCard", headers)

            dispatchSuccessWrap(actionTypes.DELETE_CARD, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

export const updatePayTerms = (customerId, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            recurringPayTermsAgreedOn: moment().format('llll')
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/payTerms", data, headers)

            dispatchSuccessWrap(actionTypes.UPDATE_PAY_TERMS, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}

export const addNewCard = (token, customerId, payTermsAndCond, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            stripeToken: token
        }
        if (!payTermsAndCond) {
            // If no previously paid terms and conditions
            data.recurringPayTermsAgreedOn = moment().format('llll');
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/addCard", data, headers)
            if (payload.data && payload.data.card) {
                let dataForMakingDefault = {
                    cardId: payload.data.card.id
                }
                await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
            }
            dispatchSuccessWrap(actionTypes.ADD_CARD, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}

export const addNewBankAcct = (token, customerId, payTermsAndCond, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            stripeToken: token
        }

        if (!payTermsAndCond) {
            // If no previously paid terms and conditions
            data.recurringPayTermsAgreedOn = moment().format('llll');
        }
        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/addCard", data, headers)
            if (payload.data && payload.data.card) {
                /* let dataForMakingDefault = {
                     cardId: payload.data.card.id
                 }*/
                // await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
                dispatchSuccessWrap(actionTypes.ADD_BANK_ACCT, { resp: payload }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}


export const addNewBankAcctAndMakeDefault = (token, customerId, payTermsAndCond, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            stripeToken: token
        }

        if (!payTermsAndCond) {
            // If no previously paid terms and conditions
            data.recurringPayTermsAgreedOn = moment().format('llll');
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/addCard", data, headers)
            if (payload.data && payload.data.card) {
                let dataForMakingDefault = {
                    cardId: payload.data.card.id
                }
                await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
                dispatchSuccessWrap(actionTypes.ADD_BANK_ACCT, { resp: payload }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}


export const verfiySource = (customerId, source, amt1, amt2, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            source: source,
            amt1: amt1,
            amt2: amt2
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/verify", data, headers)
            if (payload.data && payload.data.card) {
                let dataForMakingDefault = {
                    cardId: payload.data.card.id
                }
                await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
                dispatchSuccessWrap(actionTypes.VERIFY_SOURCE, { resp: payload }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }

}


export const updateBillingMethod = (billingMethod, subscriptionId) => {
    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            billingMethod: billingMethod
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/subscription/' + subscriptionId + '/billingMethod', data, headers)
            console.log(payload)
            // dispatchSuccessWrap(actionTypes.NAME_CHANGE, { resp: payload }, dispatch)

        } catch (error) {
        }

    }
}



export const changeAllcalName = (name) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            name: name
        }

        try {
            const payload = await axios.put(constants.apiUrl + '/accounts/' + localStorage.getItem('userId'), data, headers)
            console.log(payload)
            dispatchSuccessWrap(actionTypes.NAME_CHANGE, { resp: payload }, dispatch)

        } catch (error) {
        }
    }
}

/**
 * Sign-up's details save: PUT /organization/:orgId/paper with the body from
 * signupPaperBody (components/shared/signupDetails.js).
 *
 * cb(null, { data, warnings }) on success; cb({ status, code, message }) when
 * the API refuses (4xx/5xx { error: true, code, message }, or a 200 with
 * error: true) or the request fails.
 */
export const updateInfoForPaperMember = (body, loginToken, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/paper', body, headers)
            const data = (payload && payload.data) || {}
            if (data.error) {
                return cb({ status: payload.status || 0, code: data.code || null, message: data.message || null })
            }
            dispatchSuccessWrap(actionTypes.UPDATED_MEMBER_INFO, { resp: payload }, dispatch)
            cb(null, { data: data.data, warnings: data.warnings || [] })
        } catch (error) {
            cb(apiFailure(error))
        }
    }
}

/**
 * My Account "Edit details" save (specs/customer-sync, T9): one
 * PUT /organization/:orgId/paper naming the member's own row by its _id
 * (rowId) and the login (allcalUserId), never by email. `fields` holds only
 * what the member changed; `clear` lists the fields they emptied (never email).
 *
 * cb(null, { data, warnings }) on success; cb({ status, code, message })
 * when the API refuses (4xx/5xx with { error: true, code, message }).
 */
export const saveMyMemberRecord = ({ rowId, allcalUserId, fields, clear }, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }
        const body = { ...(fields || {}) }
        if (rowId) {
            body.rowId = rowId
        }
        if (allcalUserId) {
            body.allcalUserId = allcalUserId
        }
        if (clear && clear.length) {
            body.clear = clear.filter((k) => k !== 'email')
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/paper', body, headers)
            const data = (payload && payload.data) || {}
            if (data.error) {
                return cb({ status: payload.status || 0, code: data.code || null, message: data.message || null })
            }
            dispatchSuccessWrap(actionTypes.UPDATED_MEMBER_INFO, { resp: payload }, dispatch)
            cb(null, { data: data.data, warnings: data.warnings || [] })
        } catch (error) {
            cb(apiFailure(error))
        }
    }
}

export const getSavedMemberInfo = (memberId, callback) => {
    return async (dispatch, getState) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        try {
            const payload = await axios.get(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/member/' + memberId, headers);
            if (payload.data && !payload.data.error && payload.data) {
                callback(null, payload.data.data);
            } else {
                callback('No member info found')
            }
        } catch (err) {
            callback(err);
        }
    }
}

export const getUpcomingInvoice = (custId, callback) => {
    return async (dispatch, getState) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }
        try {
            const payload = await axios.get(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/cust/' + custId, headers);
            if (payload.data && !payload.data.error && payload.data) {
                callback(null, payload.data.data);
            } else {
                callback('No upcoming invoice found')
            }
        } catch (err) {
            callback(err);
        }
    }
}



// GET by the login's id; when there is no login id, or it finds nothing
// (error: true, or a 4xx/5xx), GET by email instead.
const byLoginThenEmail = async (userId, byLoginUrl, byEmailUrl, headers) => {
    if (userId && userId !== 'undefined') {
        try {
            const res = await axios.get(byLoginUrl, headers)
            if (res && res.data && !res.data.error) {
                return res
            }
        } catch (err) {
            // fall through to the email lookup
        }
    }
    return axios.get(byEmailUrl, headers)
}

export const getUserInfo = (userId, cb) => {
    return async (dispatch, getState) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            // The member's own records by login first (allcalUserId → their
            // row, and the row's Stripe customer id), and by email only when
            // the login finds nothing (specs/customer-sync, T9).
            const byEmail = encodeURIComponent(localStorage.getItem('email'))
            const orgUrl = constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg
            const payload = await byLoginThenEmail(userId,
                orgUrl + '/user/' + userId + '/stripe/customer',
                orgUrl + '/user/undefined/stripe/customer?email=' + byEmail, headers)
            const payloadPaper = await byLoginThenEmail(userId,
                orgUrl + '/user/' + userId + '/paper',
                orgUrl + '/user/undefined/paper?email=' + byEmail, headers)
            const payloadRegInfo = await byLoginThenEmail(userId,
                constants.dashboardBaseUrl + "/org/" + constants.selectedOrg + '/user/' + userId + '/registrationInfo',
                constants.dashboardBaseUrl + "/org/" + constants.selectedOrg + '/user/undefined/registrationInfo?email=' + byEmail, headers)
            let consolidatedRespData = {};
            let stripeUserInfo = {};
            let paperInfo = {}
            let regUserInfo = {}
            if (payload.data && payload.data.data) {
                console.log(payload.data);
                stripeUserInfo = payload.data.data
                let futureInvoiceItems = []
                let cardSources = []
                stripeUserInfo.invoiceItems.forEach((invoice) => {
                    // if (moment(invoice.date * 1000).isSameOrAfter(moment(new Date()).startOf('month'))) {
                    futureInvoiceItems.push(invoice);
                    // }
                })

                stripeUserInfo.sources && stripeUserInfo.sources.data && stripeUserInfo.sources.data.length > 0 && stripeUserInfo.sources.data.forEach((card) => {
                    //if (card.object === 'card') {
                    cardSources.push(card)
                    //}
                })
                stripeUserInfo.invoiceItems = futureInvoiceItems;
                if (stripeUserInfo.sources &&
                    stripeUserInfo.sources.data) {
                    stripeUserInfo.sources.data = cardSources
                }
            } else {
                stripeUserInfo.stripeUserInfoExists = false;
            }
            if (payloadPaper.data && payloadPaper.data.data) {
                paperInfo = payloadPaper.data.data
            } else {
                paperInfo.paperInfoExists = false;
            }

            if (payloadRegInfo.data && payloadRegInfo.data.data) {
                regUserInfo = payloadRegInfo.data.data
            } else {
                regUserInfo.regUserInfoExists = false
            }

            consolidatedRespData = {
                ...stripeUserInfo,
                ...paperInfo,
                ...regUserInfo,
                // The Allcal row itself, kept apart from the merge above
                // (registration info can carry its own _id and email): the
                // edit form starts from it and saves to it by its _id.
                memberRow: paperInfo.paperInfoExists === false ? null : paperInfo
            }
            console.log(consolidatedRespData)
            //console.log('payload cal Info', payload);
            dispatchSuccessWrap(actionTypes.GET_USER_INFO, {
                consolidatedRespData: consolidatedRespData
            }, dispatch)
            cb(null, consolidatedRespData)

        } catch (error) {
            dispatchErrorWrap(actionTypes.ERROR, dispatch)
            cb('Error fetching user info')
        }

    }
}

/*
export const getPaperInfoForUser = (userId, cb) => {
    return async (dispatch, getState) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {

            //console.log('payload cal Info', payload);
            if (payload.data && payload.data.data) {
                dispatchSuccessWrap(actionTypes.GET_PAPER_INFO, {
                    paperInfo: payload.data.data
                }, dispatch)
            } else {
                dispatchErrorWrap(actionTypes.ERROR, dispatch)
            }

        } catch (error) {
            dispatchErrorWrap(actionTypes.ERROR, dispatch)
        }

    }
} */
/*
export const getRegistrationInfoForUser = (userId, cb) => {
    return async (dispatch, getState) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {

            //console.log('payload cal Info', payload);
            if (payload.data && payload.data.data) {
                dispatchSuccessWrap(actionTypes.GET_REGISTRATION_INFO, {
                    regInfo: payload.data.data
                }, dispatch)
            } else {
                dispatchErrorWrap(actionTypes.ERROR, dispatch)
            }

        } catch (error) {
            dispatchErrorWrap(actionTypes.ERROR, dispatch)
        }

    }
} */
